import * as React from 'react'
import useSwipe from '../../../hooks/useSwipe'

const DropdownMenuContainer = ({ selectedDropDown, dropDownIndex, children, setDropDown }) => {
  const handleSwipe = direction => {
    if (direction === 'RIGHT') {
      setDropDown(0) // Resets dropdown state
    }
  }

  const swipeHandler = useSwipe(handleSwipe)

  return (
    <div
      className={
        (selectedDropDown === dropDownIndex
          ? ' left-[3rem] md:left-[11.25rem] lg:flex border-l '
          : ' left-[65rem] lg:hidden ') +
        ' absolute top-0 lg:top-9 xl:top-10 z-[101] overflow-y-auto overflow-x-hidden w-[calc(100vw-3em)] h-full flex flex-col text-gray-600 duration-300 ease-in-out ' +
        ' md:w-[calc(100vw-11.25rem)] ' +
        ' indent-5  lg:indent-0 lg:left-0 lg:z-40 lg:min-h-[300px] lg:flex-row lg:space-x-5 bg-white lg:p-3 lg:px-10 lg:text-black lg:shadow-md lg:w-full lg:top-0 lg:overflow-y-hidden '
      }
      {...swipeHandler}
    >
      <div className="fade-text lg:mx-auto grid max-w-[1366px] grid-cols-1 lg:grid-cols-4 lg:px-0 w-[calc(100vw-3rem)]">
        {children}
      </div>
      <div className="grow w-full bg-gray-100 lg:hidden" />
    </div>
  )
}
export default DropdownMenuContainer
